/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAggregationStrategy } from './InternalApiAggregationStrategy';
import {
    InternalApiAggregationStrategyFromJSON,
    InternalApiAggregationStrategyFromJSONTyped,
    InternalApiAggregationStrategyToJSON,
    InternalApiAggregationStrategyToJSONTyped,
} from './InternalApiAggregationStrategy';
import type { InternalApiAggregationOperation } from './InternalApiAggregationOperation';
import {
    InternalApiAggregationOperationFromJSON,
    InternalApiAggregationOperationFromJSONTyped,
    InternalApiAggregationOperationToJSON,
    InternalApiAggregationOperationToJSONTyped,
} from './InternalApiAggregationOperation';

/**
 * 
 * @export
 * @interface InternalApiAggregationsDetectionResultAggregationsInner
 */
export interface InternalApiAggregationsDetectionResultAggregationsInner {
    /**
     * 
     * @type {string}
     * @memberof InternalApiAggregationsDetectionResultAggregationsInner
     */
    name: string;
    /**
     * 
     * @type {InternalApiAggregationOperation}
     * @memberof InternalApiAggregationsDetectionResultAggregationsInner
     */
    operation: InternalApiAggregationOperation;
    /**
     * 
     * @type {InternalApiAggregationStrategy}
     * @memberof InternalApiAggregationsDetectionResultAggregationsInner
     */
    strategy: InternalApiAggregationStrategy;
    /**
     * Might be missing, in this case there is no limit for data start time
     * @type {Date}
     * @memberof InternalApiAggregationsDetectionResultAggregationsInner
     */
    dataStartTime?: Date;
}



/**
 * Check if a given object implements the InternalApiAggregationsDetectionResultAggregationsInner interface.
 */
export function instanceOfInternalApiAggregationsDetectionResultAggregationsInner(value: object): value is InternalApiAggregationsDetectionResultAggregationsInner {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('operation' in value) || value['operation'] === undefined) return false;
    if (!('strategy' in value) || value['strategy'] === undefined) return false;
    return true;
}

export function InternalApiAggregationsDetectionResultAggregationsInnerFromJSON(json: any): InternalApiAggregationsDetectionResultAggregationsInner {
    return InternalApiAggregationsDetectionResultAggregationsInnerFromJSONTyped(json, false);
}

export function InternalApiAggregationsDetectionResultAggregationsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAggregationsDetectionResultAggregationsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'operation': InternalApiAggregationOperationFromJSON(json['operation']),
        'strategy': InternalApiAggregationStrategyFromJSON(json['strategy']),
        'dataStartTime': json['dataStartTime'] == null ? undefined : (new Date(json['dataStartTime'])),
    };
}

export function InternalApiAggregationsDetectionResultAggregationsInnerToJSON(json: any): InternalApiAggregationsDetectionResultAggregationsInner {
    return InternalApiAggregationsDetectionResultAggregationsInnerToJSONTyped(json, false);
}

export function InternalApiAggregationsDetectionResultAggregationsInnerToJSONTyped(value?: InternalApiAggregationsDetectionResultAggregationsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'operation': InternalApiAggregationOperationToJSON(value['operation']),
        'strategy': InternalApiAggregationStrategyToJSON(value['strategy']),
        'dataStartTime': value['dataStartTime'] == null ? value['dataStartTime'] : value['dataStartTime'].toISOString(),
    };
}

